import 'normalize.css'
import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  *, h1, h2, h3, h4, h5, h6, p  {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  html, body {
    font-family: 'Lato', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    max-width: 100%;
    overflow-x: hidden;
    scroll-behavior: smooth;
  }

`
